<template>
<el-scrollbar
  :class="['dashboard-layout-scrollbar', dashboardTheme]"
  :ref="scrollbarRef"
  :style="dashboardLayoutStyle"
>
<!-- 애니메이션, 그라데이션 배경 -->
<w-particle-background :options="aniOptions" v-if="dashboardTheme === DashboardConst.THEME.PARTICLE"></w-particle-background>
<w-gradient-background :options="aniOptions" v-if="dashboardTheme === DashboardConst.THEME.GRADIENT"></w-gradient-background>
  <div :class="$style['empty-dashboard']" v-if="isEmptyDashboardTree">
    <div class="no_map_box" style="margin-left: -24px; margin-top: -24px;">
      <p class="no_map_title"><label>데이터가 없습니다.</label></p>
      <p class="no_map_desc"><label>대시보드를 추가해주십시오.</label></p>
    </div>
  </div>
  <drop
    :class="[visiblePlaceHolder, $style['dashboard-layout']]"
    @drop="onDropNode"
    @dragover="onDragOver">
    <grid-layout
      ref="gridLayout"
      :layout="widgetLayout"
      :col-num="DashboardConst.GRID_LAYOUT_OPTION.COL_NUM"
      :margin="DashboardConst.GRID_LAYOUT_OPTION.MARGIN"
      :vertical-compact="DashboardConst.GRID_LAYOUT_OPTION.VERTICAL_COMPACT"
      :row-height="layoutRowHeight"
      :is-draggable="isEditMode"
      :is-resizable="isEditMode"
      :use-css-transforms="isUseCssTransforms"
      @layout-updated="onLayoutUpdated">
      <grid-item
        v-for="widget in widgetLayout"
        :class="[widgetCls(widget.widgetTemplId), viewMode]"
        ref="gridItem"
        :key="widget.i"
        :x="widget.x"
        :y="widget.y"
        :w="widget.w"
        :h="widget.h"
        :i="widget.i"
        :min-w="getMinMaxWH('MIN', 'W', widget.widgetTemplId)"
        :max-w="getMinMaxWH('MAX', 'W', widget.widgetTemplId)"
        :min-h="getMinMaxWH('MIN', 'H', widget.widgetTemplId)"
        :max-h="getMinMaxWH('MAX', 'H', widget.widgetTemplId)"
        @resized="onLayoutItemResized">
          <component :is="widgetView(widget)" :layout="widget" />
      </grid-item>
    </grid-layout>
  </drop>
  <!-- <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/> -->
  <w-refresh-timer v-if="isMonitoringMode" @refresh="widgetLoadData" type="DASHBOARD"></w-refresh-timer>
</el-scrollbar>
</template>

<script>
import msgUtil from '@/utils/message';
import { GridLayout, GridItem } from 'vue-grid-layout';
import { Drop } from 'vue-drag-drop';
import html2canvas from 'html2canvas';

import forEach from 'lodash/forEach';
import find from 'lodash/find';
import maxBy from 'lodash/maxBy';
import max from 'lodash/max';
import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';

// import MenuDefine from '@/constants/menu';
import DashboardConst from '@/constants/dashboard';

import Layout from '@/mixins/dashboard/layout';
import Base from '@/mixins/dashboard/base';
import ScrollbarMixin from '@/mixins/scrollbar';
import WParticleBackground from '@/views/dashboard/components/frame/ParticleBackground';
import WGradientBackground from '@/views/dashboard/components/frame/GradientBackground';
import WRefreshTimer from '@/views/dashboard/components/RefreshTimer';

export default {
  name: 'WDashbordGridLayout',
  components: {
    GridLayout,
    GridItem,
    Drop,
    WParticleBackground,
    WGradientBackground,
    WRefreshTimer,
  },
  mixins: [Layout, ScrollbarMixin, Base],
  data() {
    return {
      /**
       * 위젯 높이값
       * @type {Number}
       */
      layoutRowHeight: 0,

      /**
       * 새로 추가하는 위젯 좌표 임시 데이터
       * @type {[type]}
       */
      tempWidgetPos: null,
      isUseCssTransforms: true,
      aniOptions: {
        backgroundColor: '#2961b6',
        color: '#99c2fe',
        gradientColors: ['#4367e4', '#25a3db', '#38d2cb', '#654fd9'],
        // #5371dc', '#46afe1', '#2fcfc6', '#7761ef
      },
    };
  },
  computed: {
    widgetCls() {
      return (widgetTemplId) => `${widgetTemplId}`;
    },
    /**
     * 위젯을 추가하는 상태에서는 vue-grid-item의 placeHolder를 숨김처리한다.
     *
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    visiblePlaceHolder() {
      return this.tempWidgetPos ? 'no-placeholder' : '';
    },
    /**
     * 대시보드 레이아웃 스타일
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    dashboardLayoutStyle() {
      return {
        transform: this.isFullScale ? `scale(${this.dashboardScaleX}, ${this.dashboardScaleY})` : `scale(${this.dashboardScale})`,
        width: `${this.dashboardWidth}px`,
        height: `${this.dashboardHeight}px`,
        background: `${this.backgroundStyle}`,
      };
    },
    backgroundStyle() {
      let style = 'none';

      if (this.backgroundType === DashboardConst.BACKGROUND_TYPE.COLOR) {
        style = this.dashboardData.bgColor;
      } else if (this.backgroundType === DashboardConst.BACKGROUND_TYPE.IMAGE) {
        style = `url(${this.$store.getters.getImageUrlById(this.dashboardData.customimageId)})`;
      }

      return style;
    },
    backgroundType() {
      return this.dashboardData ? this.dashboardData.bgType : DashboardConst.BACKGROUND_TYPE.COLOR;
    },
  },
  beforeCreate() {
    this.$store.commit('setDashboardType', DashboardConst.DASHBOARD_TYPE.GRID);
  },
  created() {
    // 레이아웃 업데이트 요청 이벤트 리스너
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.LAYOUT_UPDATE, this.layoutUpdate);

    // 위젯 삭제 요청 이벤트 리스너
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_DELETE, this.widgetDelete);
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_COPY, this.widgetCopy);

    // 위젯 트리의 DargStart, DragEnd 이벤트를 받아서 임시 위젯을 추가하거나 제거한다.
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_ADD_START, this.addTempWidget);
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.WIDGET_ADD_END, this.removeTempWidget);

    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.DASHBORD_IMAGE_DOWNLOAD, this.dashboardImageDownload);

    window.addEventListener('resize', this.responseLayout);
  },
  mounted() {
    // 대시보드 로드
    // this.loadDashboard(1);
    this.setScrollData();
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.LAYOUT_UPDATE, this.layoutUpdate);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_DELETE, this.widgetDelete);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_COPY, this.widgetCopy);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_ADD_START, this.addTempWidget);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.WIDGET_ADD_END, this.removeTempWidget);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.DASHBORD_IMAGE_DOWNLOAD, this.dashboardImageDownload);

    window.removeEventListener('resize', this.responseLayout);
  },
  methods: {
    widgetLoadData() {
      this.removeWidgetLoadDataTask();
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_LOAD);
      this.createWidgetLoadDataTask();
    },
    changeViewMode(isEditMode) {
      const gridLayoutEl = this.$refs.gridLayout && this.$refs.gridLayout.$el;

      // 편집 모드 일 때는 Transition 효과를 굳이 제공하지 않는다.
      if (gridLayoutEl) {
        if (isEditMode) {
          this.$refs.gridLayout.$el.classList.add('no-transition');
        } else {
          this.$refs.gridLayout.$el.classList.remove('no-transition');
        }
      }

      // 편집 모드로 진입하면 위젯을 다시 그린다.
      if (isEditMode) {
        this.$store.commit('resetDashboardData');
      }
    },
    loadDashboardComplete() {
      // 대시보드 로드 후 자동으로 전체화면 할지 확인
      this.autoDashboardFullScreen();

      this.responseLayout();

      // 스크롤 상단으로 이동
      const el = document.querySelector('.dashboard-layout-scrollbar > .el-scrollbar__wrap');
      if (el) {
        el.scrollTop = 0;
      }
    },
    /**
     * 대시보드 레이아웃 갱신
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    layoutUpdate() {
      this.$nextTick(() => {
        this.$refs.gridLayout.isDragging = false;
        this.$refs.gridLayout.layoutUpdate();
      });
    },
    /**
     * 레이아웃 갱신 완료 콜백
     * @author KangBonghun(toto1323)
     * @param  {[type]} newLayout [description]
     * @return {[type]}           [description]
     */
    onLayoutUpdated() {
      // 레이아웃 스크롤바 업데이트
      if (this.scrollTimeoutId) {
        clearTimeout(this.scrollTimeoutId);
      }
      this.scrollTimeoutId = setTimeout(() => {
        try {
          this.$refs[this.scrollbarRef].update();
        } catch (e) {
          // ignore
        }
      }, 1000);
    },
    /**
     * 레이아웃 아이템 사이즈 변경
     * @author KangBonghun(toto1323)
     * @param  {[type]} i              [description]
     * @param  {[type]} newH           [description]
     * @param  {[type]} newW           [description]
     * @return {[type]}                [description]
     */
    onLayoutItemResized(i, newH, newW) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_RESIZE, {
        widgetId: i,
        newH,
        newW,
      });
    },
    /**
     * 해상도에 따른 반응형 레이아웃 반응형
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    responseLayout() {
      this.updateHeight();
      this.updateWidth();

      // 위젯 resize
      setTimeout(() => {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_RESIZE);
      }, 300);
    },
    /**
     * 높이 조절
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    updateHeight() {
      const yMargin = DashboardConst.GRID_LAYOUT_OPTION.MARGIN[1];
      const marginNum = 4;
      const rowNum = 3;
      const adjust = 4;

      const minHeight = 270;
      const calcHeight = (this.$el.offsetHeight - ((yMargin * marginNum) + adjust)) / rowNum;

      this.layoutRowHeight = max([minHeight, calcHeight]);
      this.layoutUpdate();
    },
    /**
     * 너비 조절
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    updateWidth() {
      const sortArr = orderBy(cloneDeep(this.$store.state.dashboard.orgDashboardData.layoutInfo), ['y', 'x'], ['desc', 'desc']);

      forEach(sortArr, (layout) => {
        let { i, x, y, h, w } = layout;
        // 2018 기준 해상도 통계 - 1440x900:6%, 1536x864 6%
        if (this.isEditMode || !this.isResponsive || window.innerWidth > 1535) {
          // original width
        } else if (window.innerWidth > 1280) {
          i = layout.i;
          y = 0;
          h = layout.h;
          w = 2;
          if (layout.w === 1 || layout.w === 2) {
            x = layout.x === 0 || layout.x === 1 ? 0 : 2;
          } else if (layout.w === 3) {
            x = layout.x === 0 ? 0 : 2;
          } else if (layout.w === 4) {
            x = 0;
          }
        } else {
          i = layout.i;
          y = 0;
          h = layout.h;
          w = 4;
          x = 0;
        }

        this.$refs.gridLayout.eventBus.$emit('dragEvent', 'dragend', i, x, y, h, w);
        this.$refs.gridLayout.eventBus.$emit('resizeEvent', 'resizeend', i, x, y, h, w);
      });
      this.layoutUpdate();
    },
    /**
     * 위젯 삭제
     * @author KangBonghun(toto1323)
     * @param  {[type]} widget [description]
     * @return {[type]}        [description]
     */
    widgetDelete(widgetId) {
      this.$store.commit('removeWidget', widgetId);

      // 그냥 위젯 삭제 메시지는 보여주지 않는다. 굳이 필요없을듯.
      // 임시 위젯을 삭제할때는 메시지를 보여주지 않는다.
      // if (widgetId !== DashboardConst.TEMP_WIDGET_ID) {
      //   this.$message('위젯을 삭제하였습니다.');
      // }
    },
    /**
     * 위젯 복제
     * @author JungJioon(ryunnnne)
     * @param  {[type]} widget [description]
     * @return {[type]}        [description]
     */
    widgetCopy(widget) {
      if (this.validateDropWidget(widget)) {
        const newWidgetId = Number(maxBy(this.widgetLayout, 'i').i) + 1;
        // 복제할 위젯 정보
        const copyWidget = find(this.widgetLayout, ['i', widget.widgetId]);
        // 새로운 위젯 아이디로 복제 될 위젯 정보 저장
        const pasteWidget = Object.assign({}, copyWidget, {
          i: newWidgetId,
          widgetTemplId: widget.widgetTemplId,
        });
        // 복제 될 위젯 레이아웃에 추가
        const pasteWidgetObject = cloneDeep(widget);
        this.$store.commit('addWidget', pasteWidget);

        // 레이아웃 업데이트
        this.layoutUpdate();
        this.$nextTick(() => {
          pasteWidgetObject.widgetId = newWidgetId;
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_APPLY_SET, pasteWidgetObject);
        });
      }
    },
    /**
     * 임시 위젯 추가
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    addTempWidget(widget) {
      // 임시 위젯 기본 좌표
      this.tempWidgetPos = {
        x: -1,
        y: -1,
      };

      // 기존에 존재하는 임시 위젯을 정리한다.
      this.widgetDelete(DashboardConst.TEMP_WIDGET_ID);

      // 임시 위젯 레이아웃에 추가
      this.$store.commit('addWidget', {
        x: 0,
        y: 0,
        w: (widget.widgetTemplId === 'VmsSummaryWidget') ? 2 : 1,
        h: (widget.widgetTemplId === 'VmsSummaryWidget') ? 2 : 1,
        i: DashboardConst.TEMP_WIDGET_ID,
        widgetTemplId: widget.widgetTemplId,
      });

      // 레이아웃 업데이트
      this.layoutUpdate();
    },
    /**
     * 임시 위젯 삭제
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    removeTempWidget() {
      this.widgetDelete(DashboardConst.TEMP_WIDGET_ID);
      this.tempWidgetPos = null;
      this.layoutUpdate();
    },
    /**
     * 임시 위젯을 드래그 하는 위치로 이동시킨다.
     *
     * @author KangBonghun(toto1323)
     * @param  {[type]} data [description]
     * @param  {[type]} evt  [description]
     * @return {[type]}      [description]
     */
    onDragOver(data, evt) {
      let x = null;
      let y = null;

      const px = evt.layerX;
      const py = evt.layerY;

      x = Math.abs(Math.floor(px / (this.$refs.gridLayout.$el.clientWidth / 4)));
      y = Math.abs(Math.floor(py / this.layoutRowHeight));

      // 이전 위치값과 비교하여 변경 될 경우에만 업데이트한다.
      if (this.tempWidgetPos && (this.tempWidgetPos.x !== x || this.tempWidgetPos.y !== y)) {
        this.tempWidgetPos = { x, y };

        // 레이아웃에 Item(위젯) 위치 변경 요청 이벤트를 날린다.
        this.$refs.gridLayout.eventBus.$emit('dragEvent', 'dragend', DashboardConst.TEMP_WIDGET_ID, x, y, 1, 1);
      }
    },
    /**
     * 드랍하면 임시 위젯을 드랍한 위젯으로 변경한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} node [description]
     * @param  {[type]} e    [description]
     * @return {[type]}      [description]
     */
    onDropNode(node) {
      if (this.validateDropWidget(node)) {
        const newWidgetId = Number(maxBy(this.widgetLayout, 'i').i) + 1;

        this.$store.commit('addWidget', Object.assign({}, find(this.widgetLayout, ['i', DashboardConst.TEMP_WIDGET_ID]), {
          i: newWidgetId,
          widgetTemplId: node.widgetTemplId,
        }));

        // 위젯 설정 팝업창 오픈
        this.$nextTick(() => {
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_EDIT, this.dashboardWidget[newWidgetId], true);
        });

        // const tempWidget = find(this.widgetLayout, ['i', DashboardConst.TEMP_WIDGET_ID]);
        // tempWidget.i = Number(maxBy(this.widgetLayout, 'i').i) + 1;
        // tempWidget.widgetTemplId = node.widgetTemplId;
      }
    },
    /**
     * Drop 위젯 유효성 검사
     * @author KangBonghun(toto1323)
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    validateDropWidget(node) {
      return true;
    },
    /**
     * 대시보드 이미지 다운로드
     * @author JungJioon(ryunnnne)
     * @return {[type]} [description]
     */
    dashboardImageDownload() {
      const gridItem = this.$refs.gridItem;
      // 대시보드를 화면에 표현된 그대로 보여주기 위해 css의 transforms 속성 사용 안하도록 변경
      this.changeUseCssTransforms(gridItem, false, true);
      this.$nextTick(() => {
        const dashboard = this.$refs.gridLayout;
        const el = dashboard.$el;
        const fileName = this.$store.getters.getDashboardData.dashboardName;

        // 대시보드레이아웃 dom의 el을 html2canvas에 넘겨 해당 부분 이미지 화 하도록 설정
        html2canvas(el, {
          logging: false,
          async: false,
          backgroundColor: '#F4F4F5',
        }).then((canvas) => {
          const dataURL = canvas.toDataURL('image/png').replace('data:image/png', 'data:application/octet-stream');
          const link = document.createElement('a');
          link.href = dataURL;
          link.download = `${fileName}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.changeUseCssTransforms(gridItem, true, false);
        }).catch((error) => {
          console.log(error);
        });
      });
    },
    /**
     * GridLayout의 css의 transforms 속성 사용 안하도록 변경
     * @author JungJioon(ryunnnne)
     * @param  {[type]}  gridItem         [description]
     * @param  {[type]}  useCssTransforms [description]
     * @param  {Boolean} isChangeStyle    [description]
     * @return {[type]}                   [description]
     */
    changeUseCssTransforms(gridItem, useCssTransforms, isChangeStyle) {
      gridItem.forEach((item) => {
        item.useCssTransforms = useCssTransforms;
      });
      if (isChangeStyle) {
        this.$nextTick(() => {
          gridItem.forEach((item) => {
            item.createStyle();
          });
        });
      }
    },
    /**
     * 위젯의 widgetTemplId에 따라 width heigt 속성의 min, max값 반환
     * @author JungJioon(ryunnnne)
     * @param  {[type]} type          [description]
     * @param  {[type]} attr          [description]
     * @param  {[type]} widgetTemplId [description]
     * @return {[type]}               [description]
     */
    getMinMaxWH(type, attr, widgetTemplId) {
      return (widgetTemplId === 'VmsSummaryWidget') ? 2 : Number(`DashboardConst.GRID_LAYOUT_OPTION.${type}_${attr}`);
    },
  },
};
</script>

<style>
.vue-grid-layout.no-transition .vue-grid-item {
  transition: none;
}

.vue-grid-item {
  background-color: #ffffff;
  -webkit-box-shadow: 0px 3px 9px -5px rgba(0,0,0,.4);
  box-shadow: 0px 3px 9px -5px rgba(0,0,0,.4);
}

.vue-grid-item.vue-grid-placeholder {
  border-radius: 5px;
  border: 1px dotted #80afd3 !important;
  background: #f0f4f7 !important;
  /* border: 1px dotted #5493d3 !important; */
  /* background: #f5f7fa !important; */
  opacity: 1 !important;
}

.theme_black .vue-grid-item.vue-grid-placeholder,
.theme_gradient .vue-grid-item.vue-grid-placeholder,
.theme_particle .vue-grid-item.vue-grid-placeholder {
  background: rgba(240, 244, 247, 0.3) !important;
}


.no-placeholder .vue-grid-placeholder {
  display: none !important;
}
.dashboard-layout-scrollbar {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  display: block;
  position: relative;
  margin: -20px 0 0 -20px;
  padding: 20px 0 0 20px;
  background-size: 100% 100% !important;
}
.dashboard-layout-scrollbar > .el-scrollbar__wrap {
  overflow-y: scroll;
}
</style>
<style module>
.dashboard-layout {
  margin: -10px 14px 14px -10px;
}
.empty-dashboard {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/GridDashboardLayout.vue